import { useEffect } from 'react';
import styles from './SingleHero.module.scss';
import { Typography } from '@mui/material';
import {
  FACEBOOK_ICON,
  MAIL_ICON,
  TWITTER_ICON,
} from '../../../../../src/assets/images/icons';
import Image from 'next/image';
import { useState } from 'react';
import { format } from 'date-fns';
import { dbDateToJSDate } from '../../../../../commons/utils';
import Link from 'next/link';
import { useRouter } from 'next/router';

const SingleHero = ({ data }) => {
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');
  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      setCurrentUrl(window.location.href);
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  const socialMenu = {
    name: 'Connect',
    items: [
      {
        icon: <TWITTER_ICON fill="#004152" />,
        link: `https://twitter.com/intent/tweet?url=${currentUrl}`,
      },
      {
        icon: <FACEBOOK_ICON fill="#004152" />,
        link: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
      },
      {
        icon: <MAIL_ICON fill="#004152" />,
        link: `mailto:?body=${currentUrl}`,
      },
    ],
  };

  //handle to share the blog to FB and X
  const handleShare = (URL) => {
    setCurrentUrl(window.location.href);
    if (typeof window !== 'undefined' && !URL.includes('mailto')) {
      window.open(URL, '_blank', 'width=300,height=200');
    }
  };

  const dateFormat = data?.date?.replace('T', ' ');

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.singleHeroExtender}>
          <div className={styles.container}>
            <div className={styles.leftContainer}>
              <div>
                <div className={styles.subTitleContainer}>
                  {data?.category_collection?.map((data, i) => {
                    return (
                      <>
                        <Link href={`/resources/category/${data.slug}`}>
                          <a>
                            <Typography
                              variant="h4"
                              color="primary.main"
                              className={styles.subTitle}
                              key={data.id}
                            >
                              {data.name}
                            </Typography>
                          </a>
                        </Link>
                        <div className={styles.commaSeparator}>
                          {i < data.length - 1 && ','}
                        </div>
                      </>
                    );
                  })}
                </div>

                <Typography
                  variant="h1"
                  color="primary.main"
                  className={styles.mainTitle}
                >
                  {data?.title?.rendered}
                </Typography>
                <div className={styles.textContent}>
                  <Typography variant="article" color="primary.black">
                    {data?.custom_fields?.custom_except}
                  </Typography>
                </div>
              </div>
              <div className={styles.footer}>
                <Typography
                  variant="h5"
                  color="primary.main"
                  className={styles.date}
                >
                  {format(dbDateToJSDate(dateFormat), 'PP')}
                </Typography>
                <div className={styles.splitter}></div>
                <Typography variant="h5" color="primary.main">
                  Share:
                </Typography>
                {socialMenu.items.map((item) => {
                  return (
                    <div className={styles.socialIcons} key={item.id}>
                      <a
                        onClick={() => handleShare(item.link)}
                        href={item.link}
                        target="_blank"
                      >
                        {item.icon}
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.rightContainer}>
              <div className={styles.imageContainer}>
                <Image
                  alt={data?.title?.rendered}
                  layout="fill"
                  src={data?.featured_image?.url}
                  loading="eager"
                  objectFit="cover"
                  blurDataURL={data?.featured_image?.url}
                  placeholder="blur"
                  className={styles.imageContainerImg}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleHero;
